<template lang="pug">
	.creative-create(v-if="showed")
		.card
			.card-header
				span Create new creative
			.card-body.collapse.show
				.form-horizontal
					button.btn.btn-primary(type="button" v-on:click="createFromTemplate()") Create playable from template
					button.btn.btn-primary(type="button" v-on:click="uploadCocosCreative()") Upload your own Cocos Creator creative
					button.btn.btn-warning(v-if="isCloneCreativeFromGitAvailable()" type="button" v-on:click="cloneCreative()") Clone creative repository
					button.btn.btn-warning(type="button" v-on:click="request()") Request custom playable ad development
					button.btn.btn-dark(type="button" v-on:click="close()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { User } 			from './../../services/User'
	import { Publisher } 		from './../../services/Publisher'
	import { Monitoring } 		from './../../services/Monitoring'

	export default {
		name: "PlayableCreate",
		mixins: [Screen],
		screen: {
			events: {
				"Show PlayableCreate": function() {

					this.showed = true;

				}
			}
		},
		data() {

			return {
				showed: false
			};

		},
		methods: {
			collectData() {


			},
			createFromTemplate() {

				Broadcast.call("Show PlayableCreateFromTemplate");

				this.hide();

			},
			uploadCocosCreative() {

				Broadcast.call("Show PlayableCreateFromCocosCreator");

				this.hide();

			},
			cloneCreative() {

				if (Monitoring.getChannelState('clone-creative') !== 'done') {

					Broadcast.call("Show MonitoringLog", ["clone-creative"]);

				} else {

					Broadcast.call("Show CloneCreativeRepository");

				}

				this.hide();

			},
			request() {

				Broadcast.call("Show PlayableCreateRequest");

				this.hide();

			},
			isCloneCreativeFromGitAvailable() {

				// Разрешено админам (разработчикам)
				if (User.currentUser?.options?.access?.['clone-project-repository']) return true;

				// И разрешено админам паблишеров у которых установлен флаг GitClone в настройках паблишера
				if (User.currentUser?.Tags?.['publisher-admin'] && Publisher.SelectedPublisher?.options?.['GitClone']) return true;

				return false;

			},
			close() {

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.creative-create
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			display: flex
			width: 450px
			margin: auto
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff
				margin-top: 20px
				width: 150px

			.btn-primary
				white-space: nowrap
				width: 300px
				margin-bottom: 10px

			.btn-warning
				white-space: nowrap
				width: 300px
				margin-bottom: 10px

			.form-horizontal
				display: flex
				flex-direction: column
				align-items: center

</style>

